export default __webpack_public_path__ + "static/media/Edenred-EMP-banner-benefit-taxation.32fc69c6.jpg";